import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, NavigationEnd, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { Location } from '@angular/common';
import { NavService } from 'src/app/services/nav.service';
import { Customers } from 'src/app/model/customer';
import { CustomerService } from 'src/app/services/customer.service';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-managecustomer',
  templateUrl: './managecustomer.component.html',
  styleUrls: ['./managecustomer.component.scss']
})
export class ManagecustomerComponent implements OnInit {

  customers: Customers[] = [];
  customer$: Subscription;
  previousUrl = '';
  constructor(
    private translateService: TranslateService,
    private customerService: CustomerService, 
    private router: Router,
    private location: Location, 
    private navService: NavService) {  }

  manageCustomerForm: FormGroup;
  ngOnInit(): void {
    this.manageCustomerForm = new FormGroup({
      customerCtrl: new FormControl('')
    });

    // this.customer$ = this.navService.getCustomers().subscribe(
    //   (data) => {
    //     this.customers = data.customers;
    //   }
    // );


    this.router.events
      .pipe(filter((e: any) => e instanceof RoutesRecognized),
        pairwise()
      ).subscribe((e: any) => {
        this.previousUrl = e[0].urlAfterRedirects;
      });
  }

  setCustomer() {
    this.navService.setSelectedCustomer(this.manageCustomerForm.controls.customerCtrl.value);
    this.router.navigate(['home']);
    // this.open();
  }
  onSubmit(form: FormGroup) {
    // this.close();
  }

  close() {
    this.location.back();
  }

}
